<template>
    <div class="sortable" @click="_handleMouseUp">
        <slot></slot>
        <i class="ms-1 fas" :class="iconClass"></i>
    </div>
</template>

<style src="./SortableTh.scss"></style>

<script lang="ts" src="./SortableTh.ts"></script>
